import ValidationMessage from "../../constants/ValidationMessage";
import * as yup from 'yup';


const InviteHouseHoldValidation: any = yup.object().shape({
    household_id: yup.string().required(ValidationMessage.Field("house hold name")),

    name: yup.string().required(ValidationMessage.Field("a name"))
        .min(2, ValidationMessage?.MinLength("The name", 2))
        .max(25, ValidationMessage?.MaxLength("The name", 25)),

    member_type: yup.string().required(ValidationMessage.SelectField("a member type")),

    send_invite: yup.boolean(),

    email: yup.string()
        .test(
            'email-required',
            ValidationMessage.Field("an email address"),
            function (value) {
                const { send_invite } = this.parent;
                if (send_invite) {
                    return !!value && /^[a-zA-Z0-9.%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
                }
                return true;
            }
        )
        .max(150, ValidationMessage.MaxLength('Email', 150))
        .trim(),
});

export default InviteHouseHoldValidation